import Header from './components/Header';
import HeroSection from './components/HeroSection';
import TopicsSection from './components/TopicsSection';
import AboutSection from './components/AboutSection';
import ContactSection from './components/ContactSection';
import IndexSection from './components/IndexSection';
import MediaSection from './components/MediaSection';
import CarouselSection from './components/CarouselSection';
import AppSection from './components/AppSection';
import RankingSection from './components/RankingSection';
import CommentsSection from './components/CommentsSection';
import UpdatesSection from './components/UpdatesSection';
import FaqSection from './components/FaqSection';
import CardsSection from './components/CardsSection';
import FeaturesSection from './components/FeaturesSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Header />
      <main>
        <HeroSection />
        <TopicsSection />
        <AboutSection />
        <ContactSection />
        <IndexSection />
        <MediaSection />
        <CarouselSection />
        <AppSection />
        <RankingSection />
        <CommentsSection />
        <UpdatesSection />
        <FaqSection />
        <CardsSection />
        <FeaturesSection />
      </main>
      <Footer />
    </div>
  );
}